import { useContext } from 'react';
import './SidebarMenu.css';
import SidebarMenuController from './SidebarMenuController.js';
import { Link } from 'react-router-dom';
import { ACCOUNT_STATEMENT, Account_Statment, Booking, Dashboard as $Dashboard, DASHBOARD1, DOMESTIC_BOOKING, GLOBAL_CONTEXT, INVOICE_DETAIL, Invoice_Detail, PAGE_COOKIE_NAME, PICKUP_REQUEST, PickUp_Request, USER_TYPE_COOKIE_NAME, AD, USER_COOKIE_NAME, TRACKING, Tracking, PickUp_Status, PICKUP_STATUS, EP, Booking_Detail1, Booking_Detail2, BOOKING_DETAIL1, BOOKING_DETAIL2, LOGIN_THROTTLE_TIME } from 'mmbclient/Common/CommonVariable';
import { getCookie, setPageCookie } from 'mmbclient/Common/CommonFunctions';
import { SidebarData } from './SidebarData';

export function SidebarMenu() {

    // // State to track if the sidebar is expanded
    // const [isExpanded, setIsExpanded] = useState(false);

    // // Function to toggle the sidebar state
    // const toggleSidebar = () => {
    //     setIsExpanded(prevState => !prevState);
    // };

    const store = useContext(GLOBAL_CONTEXT);


    const { isExpanded, toggleSidebar, handleLog } = SidebarMenuController(store);

    // Function to modify the JSON data
    const modifyMenuItems = (data) => {
        const cookie = getCookie(PAGE_COOKIE_NAME);
        let page = cookie.split(',');

        let pageCount = 0;
        if (page.includes(BOOKING_DETAIL1)) {
            pageCount++;
        }
        if (page.includes(BOOKING_DETAIL2)) {
            pageCount++;
        }
        if (pageCount === 0) {
            let c = getCookie(PAGE_COOKIE_NAME);
            if (c) {
                c = "," + BOOKING_DETAIL2;   // hide booking detail 2 page                
            } else {
                c = BOOKING_DETAIL2;    // hide booking detail 2 page
            }
            setPageCookie(PAGE_COOKIE_NAME, c, LOGIN_THROTTLE_TIME);
        }

        const cookie2 = getCookie(PAGE_COOKIE_NAME);
        page = cookie2.split(',');
        // Create a new array to avoid mutating the original data
        return data.map((item) => {
            let menu = "";
            if ($Dashboard === item.title) {
                menu = DASHBOARD1;
            } else if (Booking === item.title) {
                menu = DOMESTIC_BOOKING;
            } else if (Booking_Detail1 === item.title) {
                menu = BOOKING_DETAIL1;
            } else if (Booking_Detail2 === item.title) {
                menu = BOOKING_DETAIL2;
            } else if (Invoice_Detail === item.title) {
                menu = INVOICE_DETAIL;
            } else if (Account_Statment === item.title) {
                menu = ACCOUNT_STATEMENT;
            } else if (PickUp_Request === item.title) {
                menu = PICKUP_REQUEST;
            } else if (Tracking === item.title) {
                menu = TRACKING;
            } else if (PickUp_Status === item.title) {
                menu = PICKUP_STATUS;
            }

            if (page.includes(menu)) {
                if (menu === DASHBOARD1) {
                    return { ...item, visible: false };
                } else if (menu === DOMESTIC_BOOKING) {
                    return { ...item, visible: false };
                } else if (menu === BOOKING_DETAIL1) {
                    return { ...item, visible: false };
                } else if (menu === BOOKING_DETAIL2) {
                    return { ...item, visible: false };
                } else if (menu === INVOICE_DETAIL) {
                    return { ...item, visible: false };
                } else if (menu === ACCOUNT_STATEMENT) {
                    return { ...item, visible: false };
                    // SidebarData[i].visible = false;
                } else if (menu === PICKUP_REQUEST) {
                    return { ...item, visible: false };
                } else if (menu === TRACKING) {
                    return { ...item, visible: false };
                }
            }

            if (menu === PICKUP_STATUS) {
                const userType = getCookie(USER_TYPE_COOKIE_NAME);
                if (userType === AD || userType === EP) {

                } else {
                    return { ...item, visible: false };
                }
            }

            return item;
        });
    };

    // Apply the modification
    const modifiedData = modifyMenuItems(SidebarData);

    return (
        <>
            {/* <div class="wrapper"> */}
            {/* <aside id="sidebar" className={isExpanded ? 'expand' : ''}> */}
            {/* <div class="d-flex">
                    <button class="toggle-btn" type="button" onClick={toggleSidebar}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                        </svg>
                    </button>
                    <div class="sidebar-logo">
                    </div>
                </div> */}
            <aside id="sidebar" className={isExpanded ? 'expand' : ''}>
                <div class="d-flex">
                    <button class="toggle-btn" type="button" onClick={toggleSidebar}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                        </svg>
                    </button>
                    {/* <div class="sidebar-logo">
                        <img src={(getCookie(USER_COOKIE_NAME) === '') ? "" : "/mmbclient/assets/img/" + getCookie(USER_COOKIE_NAME) + ".png"} alt="Logo" />
                    </div> */}
                    <div className="sidebar-logo">
                        <img
                            src={(getCookie(USER_COOKIE_NAME) === '') ? "" : "/mmbclient/assets/img/" + getCookie(USER_COOKIE_NAME) + ".png"}
                            alt="Logo"
                            className="img-fluid"
                            style={{ display: 'block', margin: '0 auto' }} // Center the image
                        />
                    </div>
                </div>
                <ul class="sidebar-nav">
                    {modifiedData.map((item, index) => {
                        return (
                            <>
                                {item.visible &&
                                    <li key={index} class="sidebar-item">
                                        <Link class="sidebar-link collapsed has-dropdown" data-bs-toggle="collapse"
                                            data-bs-target={"#auth" + index} aria-expanded="false" aria-controls="auth">
                                            <i class={item.iconClass}></i>
                                            <span>{item.pageName}</span>
                                        </Link>
                                        <ul id={"auth" + index} class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
                                            <li class="sidebar-item">
                                                <Link to={item.path} class="sidebar-link">{item.pageName}</Link>
                                            </li>
                                            {/* <li class="sidebar-item">
                                                    <Link to="#" class="sidebar-link">Register</Link>
                                                </li> */}
                                        </ul>
                                    </li>
                                }
                                {/* {item.visible &&
                                        <li key={index} className={item.cName} onClick={showSidebar}>
                                            <Link to={item.path}>
                                                {item.icon}
                                                <span>{item.title}</span>
                                            </Link>
                                        </li>
                                    } */}
                            </>
                        );
                    })}
                    <li class="sidebar-item">
                        <Link class="sidebar-link" onClick={handleLog} style={{ cursor: 'pointer' }}>
                            <i class="bi bi-box-arrow-right"></i>
                            <span>Logout</span>
                        </Link>
                    </li>
                    {/* <li class="sidebar-item">
                            <Link to="#" class="sidebar-link collapsed has-dropdown" data-bs-toggle="collapse"
                                data-bs-target="#auth" aria-expanded="false" aria-controls="auth">CodzSword
                                <i class="lni lni-protection"></i>
                                <span>Auth</span>
                            </Link>
                            <ul id="auth" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
                                <li class="sidebar-item">
                                    <Link to="#" class="sidebar-link">Login</Link>
                                </li>
                                <li class="sidebar-item">
                                    <Link to="#" class="sidebar-link">Register</Link>
                                </li>
                            </ul>
                        </li> */}
                    {/* <li class="sidebar-item">
                            <Link to="#" class="sidebar-link">
                                <i class="lni lni-user"></i>
                                <span>Profile</span>
                            </Link>
                        </li>
                        <li class="sidebar-item">
                            <Link to="#" class="sidebar-link">CodzSword
                                <i class="lni lni-agenda"></i>
                                <span>Task</span>
                            </Link>
                        </li>
                        <li class="sidebar-item">
                            <Link to="#" class="sidebar-link collapsed has-dropdown" data-bs-toggle="collapse"
                                data-bs-target="#auth" aria-expanded="false" aria-controls="auth">CodzSword
                                <i class="lni lni-protection"></i>
                                <span>Auth</span>
                            </Link>
                            <ul id="auth" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
                                <li class="sidebar-item">
                                    <Link to="#" class="sidebar-link">Login</Link>
                                </li>
                                <li class="sidebar-item">
                                    <Link to="#" class="sidebar-link">Register</Link>
                                </li>
                            </ul>
                        </li>
                        <li class="sidebar-item">
                            <Link to="#" class="sidebar-link">
                                <i class="lni lni-popup"></i>
                                <span>Notification</span>
                            </Link>
                        </li>
                        <li class="sidebar-item">
                            <Link to="#" class="sidebar-link">
                                <i class="lni lni-cog"></i>
                                <span>Setting</span>
                            </Link>
                        </li> */}
                </ul>
                {/* <div class="sidebar-footer">
                        <Link to="#" class="sidebar-link">
                            <a href="#" class="sidebar-link">
                                <i class="lni lni-exit"></i>
                                <span>Logout</span>
                            </a>
                        </Link>
                    </div> */}
                {/* </aside> */}
                {/* </div> */}
            </aside>
        </>
    );
}